import { array, number, object, string } from 'yup';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import {
	MAX_80_LENGTH,
	MAX_1000_LENGTH,
} from '@constants/validationMessages';

const fields = {
	title: string()
		.trim()
		.default('')
		.max(MAX_80_LENGTH, getMaxLengthErrMsg('Title', MAX_80_LENGTH))
		.required(validationErrMessages.title),
	description: string()
		.trim()
		.default('')
		.max(MAX_1000_LENGTH, getMaxLengthErrMsg('Task Description', MAX_1000_LENGTH)),
	status: object()
		.nullable()
		.required(validationErrMessages.status),
	priority: object()
		.nullable()
		.required(validationErrMessages.priority),
	milestone: object()
		.nullable(),
	startDate: number().nullable(),
	endDate: number().nullable(),
	assignees: array().nullable(),
};

export const getSchema = (isEditMode: boolean) => {
	if (isEditMode) {
		return object({ ...fields });
	}

	return object({
		...fields,
		project: object()
			.nullable()
			.required(validationErrMessages.projectName),
	});
};
